var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAuthenticated)?_c('event-overview'):_c('landing')
}
var staticRenderFns = []

export { render, staticRenderFns }